import { Injectable } from '@angular/core';
import { CommunicationManagerService } from './communication-manager.service';
import { CompanyCostItem } from '../models/company-cost-item';
import * as _ from 'lodash-es';

export interface MultiUpdateItemData {
  ids: Array<string>;
  accountingCategory?: string;
  description?: string;
  paymentMethod?: string;
  dateOfBill?: Date;
  subcategory?: string;
  assignedTo?: string;
  paidBy?: string;
  paymentDate?: Date;
  taxPercentage?: number;
  hasReminder?: boolean;
}

export const StubMultiUpdateItemData: MultiUpdateItemData = {
  ids: [],
  accountingCategory: '',
  description: '',
  paymentMethod: '',
  dateOfBill: new Date(),
  subcategory: '',
  assignedTo: '',
  paidBy: '',
  paymentDate: new Date(),
  taxPercentage: 0,
  hasReminder: false,
};

@Injectable({
  providedIn: 'root',
})
export class CompanyCostItemService {
  constructor(private cm: CommunicationManagerService) {}

  getCostItemsByCompanyId(companyId: string) {
    return this.cm.get(`companyItem/all`, [
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }

  //TODO: need BE for this
  getCostItemsByCompanyIdAndYear(companyId: string, year: number) {
    return this.cm.get(`companyItem/all/${year}`, [
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }

  createCompanyCostItem(item: CompanyCostItem) {
    const itemDto = this.cleanUpProjectCostItemObject(item);
    return this.cm.postAndGetJson(`companyItem`, itemDto, []);
  }

  cloneCompanyCostItems(ids: Array<string>) {
    const payload = { ids: ids };
    return this.cm.postAndGetJson(`companyItem/clone`, payload, []);
  }

  updateCompanyCostItemByIdRecurringCost(
    recurringCost: string,
    itemId: string,
    companyId: string
  ) {
    return this.cm.put(`companyItem/${itemId}`, { recurringCost }, [
      { headerName: 'companyId', headerValue: companyId },
    ]);
  }

  //TODO: introduce separate objects for getting and updating data
  updateCompanyCostItemById(item: CompanyCostItem) {
    const id = item._id;
    item = this.cleanUpProjectCostItemObject(item);

    delete item.company;
    return this.cm.put(`companyItem/${id}`, item, []);
  }

  multiUpdateCompanyCostItems(payload: MultiUpdateItemData) {
    //TODO: need to convert dates to locale date string, maybe in datepicker?
    //TODO: cleanup object
    return this.cm.put(`companyItem/multiple`, payload, []);
  }

  deleteCompanyItems(ids: Array<string>) {
    const payload = { ids: ids };
    return this.cm.deleteMultiple(`companyItem/multiple`, payload, []);
  }

  attachFiles(
    item: CompanyCostItem,
    type: 'invoice' | 'payment',
    files: Array<File>
  ) {
    const payload: FormData = new FormData();

    Array.from(files).forEach((f) => {
      payload.append(type, f, f.name);
    });

    // payload.forEach((f) => console.log(f));

    return this.cm.uploadAndGetJson({
      route: `companyItem/attachFile/${item._id}`,
      payload,
    });
  }

  downloadFile(item: CompanyCostItem, fileId: string) {
    return this.cm.downloadFile(
      `companyItem/downloadFile/${item._id}/${fileId}`
    );
  }

  previewFile(item: CompanyCostItem, fileId: string) {
    return this.cm.previewFile(
      `companyItem/previewFile/${item._id}/${fileId}`
    );
  }

  removeFile(item: CompanyCostItem, fileId: string) {
    return this.cm.postAndGetJson(
      `companyItem/removeFile/${item._id}/${fileId}`
    );
  }

  cleanUpProjectCostItemObject(itemObject: CompanyCostItem): CompanyCostItem {
    const unspecifiedFields: Array<string> = [
      '__v',
      '_id',
      'createdAt',
      'updatedAt',
      'tax',
      'taxedAmount',
      'deletedAt',
      'fiscalYear',
      'recurringCost',
      'documents',
      'editedBy',
    ];
    const clone: any = _.cloneDeep(itemObject);
    clone['currencyCode'] === null ? delete clone['currencyCode'] : null;
    clone['exchangeRate'] = clone['exchangeRate'] || 1;
    Object.keys(clone).forEach((field) =>
      unspecifiedFields.includes(field) ? delete clone[field] : {}
    );
    clone.paymentDate = itemObject.paymentDate
      ? (new Date(itemObject.paymentDate).toLocaleDateString('en-US') as any)
      : null;
    clone.dateOfBill = itemObject.dateOfBill
      ? (new Date(itemObject.dateOfBill).toLocaleDateString('en-US') as any)
      : null;
    // console.log(clone);
    return clone;
  }
}
